export default {
  GET_INSTRUMENTATIONS: (state) => {
    return state.instrumentations;
  },
  GET_INSTRUMENTATIONS_TASK: (state) => {
    return state.instrumentationsTask;
  },
  GET_INSTRUMENTATION_HISTORY: (state) => {
    return state.instrumentationHistory;
  },
  GET_INSTRUMENTATION_JOB_HISTORY: (state) => {
    return state.instrumentationJobHistory;
  },
  GET_INSTRUMENTATION_COUNTS_BY_SITE_ID: (state) => {
    return state.instrumentationCountsBySiteId;
  },
};
